import * as zod from 'zod'

export const requirementSchema = zod.object({
  requirementIds: zod.array(zod.coerce.number()),
})

export type RequirementForm = zod.infer<typeof requirementSchema>
